module.exports = __webpack_public_path__ + "img/ziyuan_bg.22595d4.png";